import { SingleTeacherComponent } from './components/teachers/single/single.component';
import { StarRatingModule } from 'angular-star-rating';
import { MainRoutingModule } from './main.routing';
import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { MainComponent } from './main.component';
import { CoursesComponent } from './components/courses/courses.component';
import { SharedModule } from '../shared/shared.module';
import { HomeComponent } from './components/home/home.component';

import { NgxTypedJsModule } from 'ngx-typed-js';
import { SingleCourseComponent } from './components/courses/single/single.component';
import { TeachersComponent } from './components/teachers/teachers.component';
import { SidebarComponent } from './components/courses/single/sidebar/sidebar.component';
import { SingleCourseSessionComponent } from './components/courses/session/session.component';
import { GalleryComponent } from './components/gallery/gallery.component';
import { AboutusComponent } from './components/aboutus/aboutus.component';

@NgModule({
  declarations: [MainComponent, CoursesComponent, HomeComponent, SingleCourseComponent, SingleTeacherComponent, TeachersComponent, SidebarComponent, SingleCourseSessionComponent, GalleryComponent, AboutusComponent],
  imports: [
    CommonModule,
    SharedModule,
    MainRoutingModule,
    NgxTypedJsModule
  ],
  providers: [DatePipe]
})
export class MainModule { }
